import { jsxs as e, jsx as t, Fragment as c } from "react/jsx-runtime";
import l from "classnames";
import i from "../icon/Icon.js";
import '../../assets/Tag.css';const d = "_tag_57ts6_2", g = "_icons_57ts6_10", p = "_medium_57ts6_13", u = "_small_57ts6_18", f = "_positive_57ts6_27", v = "_informative_57ts6_31", k = "_warning_57ts6_35", b = "_blocking_57ts6_39", h = "_neutral_57ts6_43", w = "_dark_57ts6_47", n = {
  tag: d,
  icons: g,
  medium: p,
  small: u,
  positive: f,
  informative: v,
  warning: k,
  blocking: b,
  neutral: h,
  dark: w
}, j = ({ children: o, className: r, icon: s, size: _ = "medium", type: m = "informative" }) => /* @__PURE__ */ e("span", { className: l(n.tag, n[m], n[_], r), children: [
  !!s && /* @__PURE__ */ t(c, { children: Array.isArray(s) ? /* @__PURE__ */ t("div", { className: n.icons, children: s.map((a) => /* @__PURE__ */ t(i, { name: a }, a)) }) : /* @__PURE__ */ t(i, { name: s }) }),
  o
] });
export {
  j as default
};
